import { ROLE_TYPES } from '@digitale-verhuurders-verklaring/core/src/models/functions/authentication/types';

import {
  type CurrentUserDto,
  currentUserQueryKey,
  currentUserRolesAsEnum,
  fetchCurrentUser,
} from '../queries/getCurrentUser';
import { queryClient } from '../queryClient';

export const authUserHasAnyRole = async (
  roles: ROLE_TYPES[],
): Promise<boolean> => {
  const user: CurrentUserDto = await queryClient.ensureQueryData({
    queryKey: currentUserQueryKey,
    queryFn: fetchCurrentUser,
  });
  const userRoles = currentUserRolesAsEnum(user.roles);
  return userRoles.some((role) => roles.includes(role));
};
